"use client";

import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import React, { useEffect, useState } from "react";

export type DropdownItem = {
  label: string;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
};

type DropdownProps = {
  icon: React.ReactNode;
  items: DropdownItem[];
  isDarkMode?: boolean;
  menuWidth?: string;
};

//------------
// モードデザイン
//------------
const LIGHT_MENUITEMS = "bg-WHITE_1";
const LIGHT_MENUITEM = "text-GRAY_1";
const LIGHT_MENUITEM_ACTIVE = "bg-GRAY_3";

const DARK_MENUITEMS = "bg-WHITE_1/10 border border-WHITE_1/50 ";
const DARK_MENUITEM = "text-WHITE_1";
const DARK_MENUITEM_ACTIVE = "bg-WHITE_1/30 text-GRAY_1";

export default function Dropdown({ icon, items, isDarkMode, menuWidth = "w-32" }: DropdownProps) {
  const [classNameMenuItems, setClassNameMenuItems] = useState("");
  const [classNameMenuItem, setClassNameMenuItem] = useState("");
  const [classNameMenuItemActive, setClassNameMenuItemActive] = useState("");

  useEffect(() => {
    if (isDarkMode) {
      setClassNameMenuItems(DARK_MENUITEMS);
      setClassNameMenuItem(DARK_MENUITEM);
      setClassNameMenuItemActive(DARK_MENUITEM_ACTIVE);
    } else {
      setClassNameMenuItems(LIGHT_MENUITEMS);
      setClassNameMenuItem(LIGHT_MENUITEM);
      setClassNameMenuItemActive(LIGHT_MENUITEM_ACTIVE);
    }
  }, [isDarkMode]);

  return (
    <Menu
      as="div"
      className="relative inline-block text-left"
    >
      <MenuButton>{icon}</MenuButton>
      <MenuItems
        modal={false} // これをしないと、メニュー表示時スクロールバーが消えて表示がずれるため注意
        transition
        anchor={{ to: "bottom end", gap: 8 }} // カード等のoverflow-hiddenでメニューが見切れないよう、ポータル経由で描画させるため指定
        className={`z-10 origin-top-right ${menuWidth} rounded-md bg-WHITE_1 shadow-md transition focus:outline-none data-[closed]:scale-95 data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in ${classNameMenuItems}`}
      >
        {items.map((item, index) => (
          <MenuItem key={index}>
            {({ active }) => (
              <button
                onClick={item.onClick}
                className={`${
                  active ? classNameMenuItemActive : ""
                } w-full rounded-md px-4 py-2 text-left text-sm ${classNameMenuItem}`}
              >
                {item.label}
              </button>
            )}
          </MenuItem>
        ))}
      </MenuItems>
    </Menu>
  );
}
